<template>
  <v-btn @click.stop="onClick" text small>
    <span id="RTE__command__bold">B</span>
  </v-btn>
</template>

<script>
export default {
  name: 'bold',
  methods: {
    onClick () {
      this.$emit('click', 'bold')
    }
  }
}
</script>

<style scoped>
#RTE__command__bold {
  font-weight: bold;
  font-size: 20px;
}
</style>
